export default "__VITE_ASSET__26X8KWNg__"